import * as z from 'zod';

import { zodDateOrString } from '../../utils';

export const FannieMaeLar96V1 = z.object({
  version: z.literal('1').describe('version'),
  lenderNumber: z.string().describe('string'),
  investor: z.literal('F').describe('literal'),
  recordIdentifier: z.literal('96').describe('literal'),
  sourceCode: z.literal('0').describe('literal'),
  fannieMaeLoanNumber: z.string().describe('string'),
  lpiDate: zodDateOrString.describe('date'),
  unpaidPrincipalBalance: z.number().describe('currency'),
  interest: z.number().describe('currency'),
  principal: z.number().describe('currency'),
  actionCode: z.enum(['00', '60', '65', '67', '70', '71', '72']).describe('enum'),
  actionDate: zodDateOrString.describe('date'),
  otherFees: z.number().describe('currency'),
  filler: z.literal('0000').describe('literal'),
});
export type FannieMaeLar96V1 = z.infer<typeof FannieMaeLar96V1>;

export const FannieMaeLar96 = FannieMaeLar96V1;
export type FannieMaeLar96 = z.infer<typeof FannieMaeLar96>;
// Make `FannieMaeLar96Report` a discriminated union on 'version' when changes happen
// export const FannieMaeLar96V2 = z.object({
//   version: z.literal('2'),
//   foo: z.string(),
// });
// export const FannieMaeLar96 = z.discriminatedUnion('version', [FannieMaeLar96V1, FannieMaeLar96V02012025]);
